import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import {
  trackEvent,
  CLICKED_UPGRADE_BANNER,
  NURTURE_BAR_TYPES,
} from '../../../util/segment';
import { PRODUCT_PLANS_PAGE_URL } from '../nurture-content';

export default function FreemiumNotificationBar(props) {
  const goToPricingPlansPage = async (event) => {
    // Stops click event from bubbling and triggering a click on parent div and opening the modal.
    event.preventDefault();
    event.stopPropagation();
    await trackEvent(CLICKED_UPGRADE_BANNER, {
      nurtureBarType: NURTURE_BAR_TYPES.freemium,
      notificationType: props.notificationType.segmentNotificationType,
    });
    window.location.href = PRODUCT_PLANS_PAGE_URL;
  };

  return (
    <div
      className={styles.freemiumNotificationWrapper}
      role="button"
      onClick={props.openModal}
      tabIndex={-1}
      onKeyPress={() => {}}
    >
      <div
        className={`${styles.freemiumNotification} ${props.limit.color[props.notificationType.id]}`}
        data-test="freemium-notification-bar"
      >
        <span className={`${styles.limitAlertSvg} ${styles.left}`}>
          {props.notificationType.alertImage}
        </span>
        {props.description(props.limit.type)}
        <a className={styles.btnUpgradeNow} type="button" onClick={goToPricingPlansPage} href={PRODUCT_PLANS_PAGE_URL}>
          Upgrade Now
        </a>
        <span className={`${styles.limitAlertSvg} ${styles.right}`}>
          {props.notificationType.alertImage}
        </span>
      </div>
    </div>
  );
}

FreemiumNotificationBar.propTypes = {
  description: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  notificationType: PropTypes.shape({
    id: PropTypes.string,
    alertImage: PropTypes.node,
    segmentNotificationType: PropTypes.string,
  }).isRequired,
  limit: PropTypes.shape({
    type: PropTypes.string,
    color: PropTypes.shape({
      default: PropTypes.string,
      caution: PropTypes.string,
      maxedOut: PropTypes.string,
    })
  }),
};

FreemiumNotificationBar.defaultProps = {
  limit: null,
};
